import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Params, Router }       from '@angular/router';
import { Location }                     from '@angular/common';

import { GroupService }                 from '../../../group.service';
import { UserService }                  from './../../../user.service';
import { ProgramRoutesService }         from '../../program-routes.service';
import { GroupUsers }                   from './../../../../../models/program/group-users';
import { User }                         from './../../../../../models/program/user';
import { ExistingUser }                 from '../../../../../models/program/existing-user';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.less']
})

export class UsersComponent implements OnInit, OnDestroy {
  private sub: any;
  private programId: number;
  public groupId: number;
  public users: GroupUsers[];
  public userArray: number[] = [];
  public groupName;
  public deleteSingle: boolean = false;
  public moveSingle: boolean = false;
  public userSettings: boolean = false;
  public selectedUser: User;

  constructor(
    private groupService: GroupService,
    private userService: UserService,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private _programRoutes: ProgramRoutesService
  ) { }

  ngOnInit(): void {
    this.programId = this.groupService.processRouteForParentId(this.route.snapshot);
    this.sub = this.route.parent.params.subscribe(params => {
      this.groupId = +params['groupId'];

      this.groupService
          .getGroup(this.programId, this.groupId)
          .subscribe(group => {
            this._programRoutes.name.next(group.name);
            this.groupName = group.name;
          });
      this.loadData(this.groupId);
    })
  }

  /**
   * Public Methods
   */

  public selectUser(user: User, settings?: boolean): void {
    if (this.selectedUser) { this.selectedUser = null; };
    if (settings) {
      this.userService.getUser(user.id)
                      .subscribe(u => this.selectedUser = u);
    } else {
      this.selectedUser = user;
    }
  }

  public deleteUser(user: User): void {
    let singleId: number[] = [];
    singleId.push(user.id);
    this.userService.deleteGroupUsers(this.programId, this.groupId, singleId)
                    .subscribe(res => {
                      this.groupService._groupId = null;
                      this.loadData(this.groupId);
                      this.deleteSingle = false;
                    });
  }

  public moveUser(id: number, groupId: number): void {
    let singleUserArray: ExistingUser[] = [{id}]
    this.userService.addGroupUsers(this.programId, groupId, singleUserArray)
                    .subscribe(res => {
                      this.moveSingle = false;
                      this.groupService._groupId = null;
                      this.loadData(this.groupId);
                    });
  }

  public checkUserArray(checked: boolean, id: number): void {
    if (checked) {
      this.userArray.push(id);
    } else {
      this.userArray.splice(this.userArray.indexOf(id), 1);
    }
  }

  public closeManager(recall: boolean): void {
    if (this.selectedUser) {
      this.selectedUser = null;
    }
    if (recall) {
      this.moveSingle = false;
      this.clearUsers();
      this.groupService._groupId = null;
      this.loadData(this.groupId);
    } else {
      this.moveSingle = false;
      this.clearUsers();
    }
  }

  public closeDrawer(recall: boolean): void {
    this.userSettings = false;
    this.selectedUser = null;
    this.loadData(this.groupId);
  }

  public goToAnalytics(): void {
    this.router.navigate(['analytics', 'snapshot', { programId: this.programId, group: this.groupId }]);
  }

  /**
   * Private Methods
   */

  private loadData(id: number): void {
    this.groupService
        .getGroupUsers(this.programId, id, true)
        .subscribe(users => this.users = users);
  }

  private clearUsers(): void {
    this.userArray = [];
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/program-list/program/groups/users/users.component.ts